import { HttpContextToken } from '@angular/common/http';

/**
 * Marca una petición como propia de la superficie de la TIENDA (M04/32). La fija quien construye la petición
 * (`ctxTienda()`); `customerHttpInterceptor` la reconoce y le pone la sesión del cliente. Es EXPLÍCITA, no adivinada por
 * sesión ni por ruta: los servicios de `/api/prosell/sales/**` los usan por igual el checkout B2B del panel y la tienda.
 */
export const IS_STOREFRONT_REQUEST = new HttpContextToken<boolean>(() => false);
